type PersonNamePart = string | null | undefined;

function toInitial(part: PersonNamePart) {
  return part ? `${part.substring(0, 1)}.` : "";
}

export function toPersonNameWithInitial(
  lastName: PersonNamePart,
  firstName: PersonNamePart,
  middleName?: PersonNamePart,
) {
  const initials = `${toInitial(firstName)}${toInitial(middleName)}`;

  return [lastName, initials].filter(Boolean).join(" ");
}
